// Simple heuristic helpers for language detection (non-exhaustive)
// Exported for testing; kept intentionally lightweight and dependency-free.
export const hasCJK = (t = '') => /[\u4E00-\u9FFF\u3400-\u4DBF\uF900-\uFAFF]/.test(t);

export const looksMostlyEnglish = (t = '') => {
  const letters = t.match(/[A-Za-z]/g)?.length || 0;
  const total = t.replace(/\s+/g, '').length;
  return total > 0 && letters / total > 0.6;
};

// Remove parenthetical transliterations containing Latin letters following non-Latin text
export const stripParentheticalTransliteration = (t = '') => t.replace(/\s*\([^)]*[A-Za-z][^)]*\)/g, '').trim();

const heuristics = { hasCJK, looksMostlyEnglish, stripParentheticalTransliteration };
export default heuristics;